import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  InputSignal,
} from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { User } from '../../../../interfaces';
import { TranslatePipe } from '@ngx-translate/core';
import { TranslationService } from '../../../../services/translation.service';

@Component({
  selector: 'general-info',
  imports: [InputTextModule, CheckboxModule, FormsModule,TranslatePipe],
  templateUrl: './general-info.component.html',
  styleUrl: './general-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeneralInfoComponent {
  user: InputSignal<User> = input.required();
  translateService = inject(TranslationService);
get fullNamePlaceholder() {
  const userValue = this.user();
 return userValue
  ? this.translateService.getTranslation('ACCOUNT_SETTINGS.GENERAL_INFO.ASSIGNED_ROLE') + ' ' +
    this.translateService.getTranslation('roles.' + userValue.role)
  : '';
}
}
